import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'RegistrationVerifyEmailWithPasswordController',
            RegistrationVerifyEmailWithPasswordController
        );

    /** @ngInject */
    function RegistrationVerifyEmailWithPasswordController(
        $stateParams,
        $state,
        UsersFactory,
        toastr
    ) {
        var vm = this;

        vm.sendDataToBackend = function () {
            UsersFactory.verifyEmailPassword({
                password1: vm.password1,
                password2: vm.password2,
                key: $stateParams.token,
                data_rec: vm.data_rec,
                tos: vm.tos,
            }).then(
                function () {
                    toastr.success('Zapisano hasło. Możesz się zalogować.');
                    $state.go('login');
                },
                function (response) {
                    for (var key in response.data) {
                        var value = response.data[key];

                        if (vm.form && key != 'non_field_errors') {
                            vm.form[key].$setValidity('error_field', true);
                        }

                        value.forEach(function (element, index, array) {
                            toastr.error(value[index]);
                        });
                    }
                }
            );
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/registration/verify_email_with_password/verify_email_with_password.controller.ts